import { noop } from 'lodash-es';
import LastLoggedInWith from '../LastLoggedInWith';
import StyledProviderBox, {
  StyledProvider,
  StyledProviderName,
} from './ProviderBox.style';
import { useTheme } from '@mui/material';

const ProviderBox = ({
  providers,
  providerKey,
  disabled,
  onProviderClick,
  lastLoggedInProviderName,
}) => {
  const theme = useTheme();
  const provider = providers[providerKey];
  const isDisabled = provider.enabled === false || disabled;
  const onClickCallback = isDisabled ? noop : () => onProviderClick(provider);
  const Logo = provider.logo[theme.palette.mode] || provider.logo.light;

  return (
    <StyledProviderBox
      data-cy={providerKey}
      key={providerKey}
      onClick={onClickCallback}
    >
      <StyledProvider disabled={isDisabled} theme={theme}>
        <Logo />
      </StyledProvider>
      {!isDisabled && (
        <LastLoggedInWith
          provider={provider}
          lastLoggedInProviderName={lastLoggedInProviderName}
        />
      )}
      <StyledProviderName>{provider.title.toUpperCase()}</StyledProviderName>
    </StyledProviderBox>
  );
};

export default ProviderBox;
